import { LoadingButton } from "@mui/lab";
import { Button,  Grid, Dialog, DialogTitle, DialogContent, DialogActions, Stack, IconButton, Chip } from "@mui/material";
import * as React from 'react'
import { apiConstants, postGeneric } from "../../../common/constants";
import { useSnackbar } from "notistack";
// import PageTitle from "../../../components/PageTitle";
import { useForm } from "react-hook-form";
import { FormProvider, RHFTextField } from "../../../common/hook-form";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';




const AddContactProfile = ({ merchantId, contactProfile, setReload }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = React.useState(false);
    const [sizePerPage, setSizePerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [contactOperation, setContactOperation] = React.useState(null);


    const ContactSchema = Yup.object().shape({
        name: Yup.string()
            .required('Name is required')
            .min(2, 'Name must be at least 2 characters'),
        phone: Yup.string()
            .required('Phone number is required')
            .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits'),
        email: Yup.string()
            .required('Email is required')
            .email('Email must be a valid email address'),
    });

    const method = useForm({
        defaultValues: {
            name: '',
            phone: '',
            email: ''
        },
        resolver: yupResolver(ContactSchema)
    });

    const {
        handleSubmit,
        reset,
        setValue
    } = method;


    const onSubmit = (data) => {
        setLoading(true)
        const payload = {
            name: data.name,
            phoneNumber: data.phone,
            email: data.email,
            status: true
        }

        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/contactProfile`, payload).then((res) => {
            console.log(res, "res");
            enqueueSnackbar("Contact Profile Added Successfully", { variant: 'success' });
            setReload(reload => reload + 1)
            reset()
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            enqueueSnackbar(err?.response?.data?.message || "Some error occurred", { variant: 'error' });
            console.log(err);
        })    // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    const handleDelete = () => {
        setLoading(true);
        const payload = {
            name: contactOperation.contact.name,
            phoneNumber: contactOperation.contact.phoneNumber,
            email: contactOperation.contact.email,
            status: false
        };

        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantId}/contactProfile`, payload).then((res) => {
            enqueueSnackbar("Contact Profile Deleted Successfully", { variant: 'success' });
            setOpenDialog(false);
            setReload(reload => reload + 1)
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            enqueueSnackbar(err?.response?.data?.message || "Some error occurred", { variant: 'error' });
            console.log(err);
        });
    };

    const handleContactOperation = (contact, operationType) => {
        setContactOperation({
            type: operationType,
            contact: contact
        });
        if (operationType === 'edit') {
            setValue('name', contact.name);
            setValue('phone', contact.phoneNumber);
            setValue('email', contact.email);
        } else {
            setOpenDialog(true);
        }
    };

    return (
        <>
            <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <RHFTextField label="Name" name="name" />
                    </Grid>
                    <Grid item xs={3}>
                        <RHFTextField label="Phone" name="phone" />
                    </Grid>
                    <Grid item xs={3}>
                        <RHFTextField label="Email" name="email" />
                    </Grid>
                    {/* <Grid item xs={12} md={6}>
                                <RHFTextField label="Pricing" name="pricing" />
                            </Grid> */}
                    <Grid item xs={3} >
                        <LoadingButton
                            loading={loading}
                            variant="contained"
                            size="small"
                            type="submit"
                            color={contactOperation?.type === 'edit' ? 'warning' : 'primary'}
                            sx={{ mt: 2, borderRadius: 1 }}
                        >
                            {contactOperation?.type === 'edit' ? 'Update' : 'Submit'}
                        </LoadingButton>
                        <Button variant="contained" size="small" color='error' sx={{ ml: 1, mt: 2, borderRadius: 1 }} onClick={() => { reset(); setContactOperation(null) }}>Reset</Button>
                    </Grid>
                </Grid>
            </FormProvider>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} md={12}>
                    <ProzoDataGrid
                        rows={contactProfile || []}
                        columns={[
                            {
                                field: 'name',
                                headerName: 'Name',
                                flex: 1,
                                minWidth: 150,
                            },
                            {
                                field: 'email',
                                headerName: 'Email',
                                flex: 1,
                                minWidth: 150,
                            },
                            {
                                field: 'phoneNumber',
                                headerName: 'Phone Number',
                                flex: 1,
                                minWidth: 150,
                            },
                            {
                                field: 'status',
                                headerName: 'Status',
                                flex: 1,
                                minWidth: 120,
                                renderCell: (params) => (
                                    <Chip
                                        label={params.value ? "Active" : "Inactive"}
                                        size="small"
                                        variant="outlined"
                                        color={params.value ? "success" : "error"}
                                    />
                                ),
                            },
                            {
                                field: 'actions',
                                headerName: 'Actions',
                                flex: 1,
                                minWidth: 120,
                                sortable: false,
                                renderCell: (params) => (
                                    <Stack direction="row" spacing={1}>
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={() => handleContactOperation(params.row, 'edit')}
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            color="error"
                                            onClick={() => handleContactOperation(params.row, 'delete')}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Stack>
                                ),
                            }
                        ]}
                        getRowId={(row) => row?.phoneNumber}
                        autoHeight
                        getRowHeight={() => 35}
                        disableSelectionOnClick
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={false}
                        paginationMode="client"
                    />
                </Grid>
            </Grid>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Delete Contact Profile</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this contact profile?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>No</Button>
                    <LoadingButton loading={loading} onClick={handleDelete} color="error">
                        Yes
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddContactProfile;